import { Component, ChangeDetectionStrategy, signal, viewChild } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import { HiddenProduct } from '@pedix-workspace/utils';

@Component({
  selector: 'pxw-product-hidden-dialog',
  templateUrl: './product-hidden-dialog.component.html',
  styleUrls: ['./product-hidden-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent],
})
export class ProductHiddenDialogComponent {
  readonly modalDialog = viewChild.required(ModalDialogComponent);

  readonly hiddenProducts = signal<HiddenProduct[]>([]);

  open(hiddenProducts: HiddenProduct[]) {
    this.hiddenProducts.set(hiddenProducts);

    return this.modalDialog().open();
  }
}
